import React, { useState } from 'react';
import { Grid, Box, Button } from '@mui/material';
import { ReactComponent as EditIcon } from '../../assets/PepWise2.0/Edit-Menu-Icon.svg';
import { ReactComponent as DeleteIcon } from '../../assets/PepWise2.0/Delete-Menu-Icon.svg';
import ProgramCard from 'components/Widgets/ProgramCard';
import PageWrapper from 'components/Common/PageWraper';
import PageHeader from 'components/Header/Page';
import { useNavigate } from 'react-router-dom';
import CreateProgramCard from 'components/Widgets/CreateProgramCard';

const programList = {
  AMESA: [
    {
      Sector_Bucket: 'AMESA',
      Program_id: 'e9693c62-f137-4af4-adc6-e715217253bb',
      Program_Name: 'Cloud 05',
      Created_dt: '2026-02-19T00:09:37.723Z',
      Updated_dt: '2026-02-19T00:09:37.723Z',
      ProjectCount: 0,
      SLA_Met_Count: 0,
      SLA_Missed_Count: 0,
      In_Progress_Count: 0,
      Scheduled_Count: 0,
    },
    {
      Sector_Bucket: 'AMESA',
      Program_id: '18af17f2-4cfd-499c-9d40-fba550f6d2c3',
      Program_Name: 'Program 01',
      Created_dt: '2026-02-13T02:41:04.690Z',
      Updated_dt: '2026-02-13T02:41:04.690Z',
      ProjectCount: 1,
      SLA_Met_Count: 0,
      SLA_Missed_Count: 1,
      In_Progress_Count: 0,
      Scheduled_Count: 0,
    },
    {
      Sector_Bucket: 'AMESA',
      Program_id: '25b9ddfe-a9a4-4985-bbd5-6723e400534b',
      Program_Name: 'Program 02',
      Created_dt: '2026-02-11T05:39:59.314Z',
      Updated_dt: '2026-02-11T05:39:59.314Z',
      ProjectCount: 8,
      SLA_Met_Count: 3,
      SLA_Missed_Count: 2,
      In_Progress_Count: 2,
      Scheduled_Count: 2,
    },
    {
      Sector_Bucket: 'AMESA',
      Program_id: '5f81e53b-3599-4559-97a0-9f865f1c6b88',
      Program_Name: 'Program 03',
      Created_dt: '2025-12-01T11:15:31.000Z',
      Updated_dt: '2025-12-01T11:15:31.000Z',
      ProjectCount: 3,
      SLA_Met_Count: 0,
      SLA_Missed_Count: 1,
      In_Progress_Count: 0,
      Scheduled_Count: 0,
    },
    {
      Sector_Bucket: 'AMESA',
      Program_id: 'ec1c7736-4bbe-4d6b-a29f-5d0f6587d4b3',
      Program_Name: 'Program 04',
      Created_dt: '2026-02-08T03:35:10.055Z',
      Updated_dt: '2026-02-08T03:35:10.055Z',
      ProjectCount: 10,
      SLA_Met_Count: 0,
      SLA_Missed_Count: 0,
      In_Progress_Count: 0,
      Scheduled_Count: 0,
    },
    {
      Sector_Bucket: 'AMESA',
      Program_id: '3f2a8d0f-c33f-4872-9e9e-08290457a99b',
      Program_Name: 'Program 05',
      Created_dt: '2025-12-24T00:33:01.500Z',
      Updated_dt: '2025-12-24T00:33:01.500Z',
      ProjectCount: 5,
      SLA_Met_Count: 0,
      SLA_Missed_Count: 0,
      In_Progress_Count: 0,
      Scheduled_Count: 0,
    },
  ],
};

const ProgramCardsSample = () => {
  const navigate = useNavigate();
  const [, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleProjectSLA = (program: any, type: string) => {
    console.log('Clicked:', program.Program_Name, type);
  };

  const onClickAddProject = (e: any, programId: string, programName: string) => {
    console.log('Add Project:', programId, programName);
  };

  const handleDetailsThreeDotsClose = () => {
    setAnchorEl(null);
  };

  const handleAction = (entity: string, action: string, program: any) => {
    console.log(`${action} clicked for`, program.Program_Name);
    handleDetailsThreeDotsClose();
  };

  return (
    <PageWrapper>
      <PageHeader title="Program Cards Demo">
        <Button variant="pepwiseSecondary" onClick={() => navigate(-1)}>
          ← Back
        </Button>
      </PageHeader>
      <Box p={3}>
        <Grid container spacing={2} mb={2}>
          <Grid item xs={12} sm={6} md={4}>
            <CreateProgramCard
              onClickCreateProgram={() => {
                console.log('Create Program Clicked');
              }}
            />
          </Grid>
        </Grid>

        {Object.entries(programList).map(([sector, programs]) => (
          <Box key={sector} mb={4}>
            <Grid container spacing={2}>
              {programs.map((program: any) => {
                const statusCount =
                  program.SLA_Missed_Count +
                  program.SLA_Met_Count +
                  (program.Scheduled_Count || 0) +
                  (program.In_Progress_Count || 0);

                return (
                  <Grid item xs={12} sm={6} md={4} key={program.Program_id}>
                    <ProgramCard
                      title={program.Program_Name}
                      programId={program.Program_id}
                      projectCount={program.ProjectCount}
                      isEditEnabled={true}
                      projectSLAs={[
                        {
                          label: 'SLA Missed',
                          count: program.SLA_Missed_Count,
                          onBtnClick: () => handleProjectSLA(program, 'SLA Missed'),
                        },
                        {
                          label: 'SLA Met',
                          count: program.SLA_Met_Count,
                          onBtnClick: () => handleProjectSLA(program, 'SLA Met'),
                        },
                        {
                          label: 'In Progress',
                          count: program.In_Progress_Count || 0,
                          onBtnClick: () => handleProjectSLA(program, 'In Progress'),
                        },
                        {
                          label: 'Scheduled',
                          count: program.Scheduled_Count || 0,
                          onBtnClick: () => handleProjectSLA(program, 'Scheduled'),
                        },
                      ]}
                      statusCount={statusCount}
                      /* INFO TOOLTIP */
                      infoTooltip={{
                        dateValues: [
                          { label: 'Date Created', value: program.Created_dt },
                          { label: 'Last Updated', value: program.Updated_dt },
                        ],
                      }}
                      /* 3 DOT MENU */
                      infoOptionMenu={{
                        menuItems: [
                          {
                            key: 'edit',
                            label: 'Edit',
                            icon: <EditIcon />,
                            onMenuClick: () => handleAction('Program', 'edit', program),
                          },
                          {
                            key: 'delete',
                            label: 'Delete',
                            icon: <DeleteIcon />,
                            onMenuClick: () => handleAction('Program', 'delete', program),
                          },
                        ],
                        sx: { width: '20px', height: '20px' },
                      }}
                      onClickAddProject={(e: any) =>
                        onClickAddProject(e, program.Program_id, program.Program_Name)
                      }
                    />
                  </Grid>
                );
              })}
            </Grid>
          </Box>
        ))}
      </Box>
    </PageWrapper>
  );
};

export default ProgramCardsSample;
